module.exports = __webpack_public_path__ + "img/icon-pay-card.bf680e44.svg";